'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { useProgressBar } from '@qogita/ui/v2/progress-bar'
import { useRouter } from 'next/navigation'

/**
 * Provides router methods that triggers the progress bar
 *
 * Each method can also be passed an action that will be executed during the transition, for instance to optimistically update the state
 *
 * @example
 * const searchParams = useSearchParams()
 * const [optimisticFilter, setOptimisticFilter] = useOptimistic(searchParams.get('filter'))
 * const progressBarRouter = useProgressBarRouter()
 *
 * function setFilter(filter: string) {
 *   progressBarRouter.push(`?filter=${filter}`, {
 *     scroll: false,
 *     action: () => {
 *       setOptimisticFilter(filter)
 *     }
 *   })
 * }
 *
 */
export function useProgressBarRouter() {
  const router = useRouter()
  const progressBar = useProgressBar()
  type NavigateOptions = Parameters<typeof router.push>[1] & {
    /** Optional action that will be executed during the transition, for instance to optimistically update the state */
    action?: () => void
  }

  function push(href: string, { action, ...options }: NavigateOptions = {}) {
    progressBar.startTransition(() => {
      /** Optimistically update the URL. This does not trigger a page reload */
      window.history.pushState(null, '', href)
      /** Trigger server navigation to fetch new data */
      router.push(href, options)
      action?.()
    })
  }

  function replace(href: string, { action, ...options }: NavigateOptions = {}) {
    progressBar.startTransition(() => {
      /** Optimistically update the URL. This does not trigger a page reload */
      window.history.replaceState(null, '', href)
      /** Trigger server navigation to fetch new data */
      router.replace(href, options)
      action?.()
    })
  }

  return { push, replace }
}
